import classNames from "classnames";

const CuratedSearchCardHeader = ({
  headerText,
  headerIcon,
  actionComponent,
}: {
  headerText: string;
  headerIcon: React.ReactNode;
  actionComponent?: React.ReactNode;
}) => {
  return (
    <div
      className={classNames(
        "text-lg",
        "flex",
        "justify-between",
        "items-center",
        "gap-2",
      )}
    >
      <div className={classNames("flex", "gap-2", "items-center")}>
        <div>{headerIcon}</div>
        <div className={classNames("font-semibold")}>{headerText}</div>
      </div>
      {actionComponent}
    </div>
  );
};

export default CuratedSearchCardHeader;
